import './UserForm.css';
import { useState } from 'react';

// https://www.w3schools.com/react/react_forms.asp

//let i=0;

// komponent formularz
export default function UserForm(){

    let title = "Formularz marzeń";

    // obiekt z parametrami marzenia
    let myDream = {
        id:0,
        name:"",
        dream:"",
        color:""
    };

    // zmienne stanu do zapamietania formularza
    const [name, setName] = useState("");
    const [dream, setDream] = useState("");
    const [color, setColor] = useState("");
    // tablica z obiektami myDream
    const [myDreams, setMyDreams] = useState([]);
    let [dreamId , setDreamId] = useState(0); 

    const handleSubmit = (event) => {
        // The preventDefault() method cancels the event if it is cancelable, 
        // meaning that the default action 
        // that belongs to the event will not occur
        // formularz nie czysci pola input
        // nie przeładowuje strony
        event.preventDefault();
        //alert(`imie: ${name}\nmarzenie: ${dream}\nkolor: ${color}`);
        myDream.id = dreamId;
        myDream.name = name;
        myDream.dream = dream;
        myDream.color = color;
        myDreams.push(myDream);
        setMyDreams(myDreams);
        dreamId++;
        setDreamId(dreamId);
      }
 
    const handleDream = (event) => {
        setDream(event.target.value);
    }  
    const handleColor = (event) => {
        setColor(event.target.value);
    } 
    
    
    return (
        <>
            <h2 style={{textAlign: 'center'}}>{title}</h2>
            <div id="leftDiv">    
                <form id="userFormForm" onSubmit={handleSubmit}>
                    <label className='userFormLabel'>Imię:<br />
                        <input 
                            type="text" 
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        /> 
                    </label>
                    <br />
                    <label className='userFormLabel'>Opis marzenia:<br />
                        <textarea value={dream} onChange={handleDream} style={{color: color}} /> 
                    </label>
                    <br />
                    <label className='userFormLabel'>Wybierz kolor: <br />
                        <select id="userFormSelect" value={color} onChange={handleColor}>
                            <option value=""></option>
                            <option value="red">red</option>
                            <option value="green">green</option>
                            <option value="blue">blue</option>
                            <option value="orange">orange</option>
                            <option value="blueviolet">blueviolet</option>
                            <option value="brown">brown</option>
                            <option value="coral">coral</option>
                            <option value="lime">lime</option>
                            <option value="magenta">magenta</option>
                        </select>
                    </label>
                    <br />
                    <input type="submit" value="dodaj marzenie" />
                </form> 
            </div> 
            <div id="rightDiv">
                
                {myDreams.map(item =>
                    <span key = {item.id} style={{color: item.color}}>
                    <p>
                        {item.id}. {item.name} ma marzenie: {item.dream} 
                    </p>
                    </span>
                )}
                
            </div>
            <div style={{clear: 'both'}}></div>
        </>
    )
}